import React from 'react';
import TableHeaderCell from './TableHeaderCell';

function TableHeaderRow({ headers }) {
    return (
        <tr className="sl-items-center sl-border-0 sl-border-b">
            {Object.values(headers).map((value, index) => (
                <TableHeaderCell key={index} content={value.data} classes={value.classes} />
            ))}
        </tr>
    );
}

export default TableHeaderRow;
